import { ReactNode } from 'react';
import './AppLayout.scss';
import LeftMenu from './LeftMenu/LeftMenu';
import Header from './Header/Header';
import { Layout } from 'antd';
import { useLocation } from 'react-router-dom';
import Footer from './Footer/Footer';
import { useAppSelector } from '../../../core/services/hooks';

interface IProps {
  children: ReactNode;
}

function AppLayout(props: IProps) {
  const location = useLocation();
  const me = useAppSelector((state) => state.app.setMe.me);
  return (
    <Layout id="app-layout" className="min-h-screen">
      <Header />
      <Layout
        className={`${
          location.pathname === '/tr/'
            ? 'flex-grow bg-[#F9F9F9]'
            : 'bg-graybg flex-grow'
        } `}
      >
        <LeftMenu />
        <Layout.Content
          className={`${
            location.pathname === '/tr/'
              ? 'flex-grow mt-6 mx-6 p-6 bg-[#F9F9F9]  '
              : 'flex-grow mt-6 mx-6 bg-white rounded-lg p-6 pb-32'
          } `}
        >
          {props.children}
        </Layout.Content>
      </Layout>
      <Footer />
    </Layout>
  );
}

export default AppLayout;
